import { useEffect } from "react";

export default function useInViewAnimate({
  selector = "[data-animate]",
  inClass = "is-inview",
  outClass = "is-outview",
  threshold = 0.15,
  rootMargin = "0px 0px -10% 0px",
  once = true,
} = {}) {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll(selector));
    if (!els.length) return;

    // estado inicial (por si querés que arranquen “apagados”)
    els.forEach((el) => {
      el.classList.add(outClass);
      el.classList.remove(inClass);
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const el = entry.target;

          if (entry.isIntersecting) {
            el.classList.add(inClass);
            el.classList.remove(outClass);
            if (once) io.unobserve(el);
          } else if (!once) {
            el.classList.remove(inClass);
            el.classList.add(outClass);
          }
        });
      },
      { threshold, rootMargin }
    );

    els.forEach((el) => io.observe(el));

    return () => io.disconnect();
  }, [selector, inClass, outClass, threshold, rootMargin, once]);
}